module.exports = __webpack_public_path__ + "static/media/skills-matrices.477a71b4.svg";